import { Box, Typography } from "@mui/material";
import React, { useCallback, useEffect, useMemo, useState } from "react";

import DownArrow from "../../../../../../styles/svg/downArrow.svg";
import note from "../../../../../../styles/svg/note.svg";
import { truncateText } from "../../../../../../utils";
import { useBoards } from "../../../../../../utils/reactQuery/boards";
import ChangeBoardToDifferentWorkflow from "./ChangeBoardToDifferentWorkflow.js";
import { useResponsive } from "../../../../../../hooks/useResponsive.js";
import "./ChangeBoardToDifferentWorkflow.scss";
import CustomMenu from "../../../../../../components/Menu/index.js";
import CustomMenuItem from "../../../../../../components/Menu/CustomMenuItem.js";
import { CustomButton } from "../../../../../../components/Button/Button.js";
function ChangeBoard({ cardId, card }) {
  const [currentBoardName, setCurrentBoardName] = useState("");
  const [openChangeBoard, setOpenChangeBoard] = useState(false);
  const isMobile = useResponsive("down", "md");

  const {
    workflow_step_id: currentWorkflowStepId,
    is_todo: isTodo,
    board: { board_id: boardId, board_name, workflow_id: currentworkflow_id },
  } = card?.data?.data?.responseData;

  const { boards } = useBoards();
  const allBoards = boards?.data?.data?.responseData || [];

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [workflowId, setWorkflowId] = React.useState(null);
  const [targetBoardName, setTargetBoardName] = React.useState(null);
  const [targetBoardId, setTargetBoardId] = React.useState(null);
  const open = Boolean(anchorEl);

  useEffect(() => {
    setCurrentBoardName(board_name);
  }, [card]);

  const filteredItems = useMemo(() => {
    return allBoards
      ?.filter(
        (item) =>
          item.board_name.toLowerCase() &&
          item.is_archive === false &&
          item.board_id !== boardId
      )
      .sort((a, b) => a.board_name.localeCompare(b.board_name));
  }, [boards, boardId]);

  const changeBoard = useCallback((workflow_id, boardName, boardId) => {
    setOpenChangeBoard(true);
    setTargetBoardName(boardName);
    setWorkflowId(workflow_id);
    setTargetBoardId(boardId);
  }, []);

  // Callbacks for handlers
  const handleAnchorClick = useCallback((event) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleMenuClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  return (
    <>
      {openChangeBoard && (
        <ChangeBoardToDifferentWorkflow
          isTodo={isTodo}
          open={openChangeBoard}
          close={setOpenChangeBoard}
          currentBoardName={
            currentBoardName && truncateText(currentBoardName, 25)
          }
          targetBoardName={targetBoardName && truncateText(targetBoardName, 25)}
          card={card}
          workflowId={workflowId}
          cardId={cardId}
          targetBoardId={targetBoardId}
          currentBoardWorkflowId={currentworkflow_id}
          currentWorkflowStepId={currentWorkflowStepId}
        />
      )}
      {isMobile ? (
        <div className="mt-2">
          <p className="filter-text">Select Target board :</p>

          <Box
            className={"workflow_steps_cont"}
            maxHeight={165}
            overflow={"auto"}
            minHeight={100}
          >
            {filteredItems?.map((board, idx) => {
              return (
                <Typography
                  key={`change-board-${board?.board_id}`}
                  className={`workflow_steps change-board-bg ${
                    board.board_id == boardId ? "change-board-bg" : ""
                  }`}
                  onClick={(event) =>
                    changeBoard(
                      board.workflow_id,
                      board.board_name,
                      board.board_id
                    )
                  }
                >
                  {truncateText(board.board_name, 26)}
                </Typography>
              );
            })}
          </Box>
        </div>
      ) : (
        <div className="mr-2">
          <CustomButton
            variant="outlined"
            color="primary"
            id="epics-board-dropdown"
            aria-haspopup="true"
            onClick={handleAnchorClick}
            endIcon={<img src={DownArrow} alt="arrow" />}
            className="white-button change-board-btn "
          >
            <p className="header-action-button-text mr-1">Change Board</p>
          </CustomButton>
          <CustomMenu
            id="user-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleMenuClose}
            className="assign-board-owner-list"
          >
            {filteredItems?.map((board, idx) => {
              return (
                <CustomMenuItem
                  key={`board-list-my-task-${idx}`}
                  className="custom-border"
                  onClick={(event) =>
                    changeBoard(
                      board.workflow_id,
                      board.board_name,
                      board.board_id
                    )
                  }
                >
                  <p className="board-name-filter">
                    {truncateText(board.board_name, 26)}
                  </p>
                </CustomMenuItem>
              );
            })}
          </CustomMenu>
        </div>
      )}
    </>
  );
}

const isChangeBoard = (prevProps, nextProps) => {
  const prevCardData = prevProps?.card?.data?.data?.responseData || {};
  const nextCardData = nextProps?.card?.data?.data?.responseData || {};

  const {
    workflow_step_id: prevWorkflowStepId,
    board: {
      board_id: prevBoardId,
      board_name: prevBoardName,
      workflow_id: prevWorkflowId,
    } = {},
  } = prevCardData;

  const {
    workflow_step_id: nextWorkflowStepId,
    board: {
      board_id: nextBoardId,
      board_name: nextBoardName,
      workflow_id: nextWorkflowId,
    } = {},
  } = nextCardData;

  // Compare all relevant props
  return (
    prevProps.cardId === nextProps.cardId &&
    prevWorkflowStepId === nextWorkflowStepId &&
    prevBoardId === nextBoardId &&
    prevBoardName === nextBoardName &&
    prevWorkflowId === nextWorkflowId
  );
};
export default React.memo(ChangeBoard, isChangeBoard);
